
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { go } from '../../libs/router'
import store from '../../vuex/store'
export default {
components: {
Group,
XHeader,
XButton,
Cell
},
data () {
return {
pullHeight: window.innerHeight,
fpDetail: {},
showEdit: false,
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '发票名片' )
},
created () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
var _this = this
var id = _this.$route.params.id
_this.$ajax.post( _this.ajaxFactory.get( 'businessCard' ), {}, {
params: { 'cardId': id }
} ).then( function ( response ) {
var result = response.data
_this.fpDetail = result.businessCard;
_this.showEdit = result.showEdit;

} )
.catch( function ( response ) {
console.log( response )
} )
},
methods: {
onClick ( link ) {
go( link, this.$router )
}
}
}



// WEBPACK FOOTER //
// ./src/components/card/viewCard.vue